<template>
  <div id="boardInfo">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>My Booth</el-breadcrumb-item>
      <el-breadcrumb-item>Standard Booth</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="formBox" :span="24">      
      <el-form style="margin-top: 30px; width:50%;" :model="ruleForm" ref="boardForm" label-position="right" label-width="200px">
        <div style="padding-bottom:15px;padding-left:38px;font-size:14px;font-weight:bold">The company names in both Chinese and English from the Catalogue Entry will be used on the fascia board</div>
        <template v-for="(item,ind) in allList">
          <template>
            <el-form-item :label="item.fieldName" :key="ind" :prop="item.fieldKey" >
            <template v-if="item.fieldKey == 'clgBoardExt1'">
              <el-input v-model="ruleForm[item.fieldKey]"  @keyup.native="inputChange($event,item.fieldKey)" disabled></el-input>
            </template>
            <template v-else>
              <el-input v-model="ruleForm[item.fieldKey]"  disabled></el-input>
            </template>
            </el-form-item>
          </template>
        </template>
        <el-form-item>
          <!-- <el-button type="primary" :style="buttonStyle" @click="submitForm" :disabled = 'saveBtnStatue'>保存</el-button> -->
        </el-form-item>
      </el-form>
    </div>    
    <div style='margin:20px 0;font-size:16px;font-weight:bold'>DOWNLOAD</div>
    <div style="padding:0px 0 10px">
      <el-button type="primary"><a :href="file0" style="font-size:14px;color:#fff;text-decoration:none;"  target="_blank">CAC2025 Exhibitor Manual</a></el-button>
      <el-button type="primary"><a :href="file1" style="font-size:14px;color:#fff;text-decoration:none;"  target="_blank" >Standard Booth Exhibitor Instructions</a></el-button>
      <!-- <el-button type="primary"><a :href="file2" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank" >CAC2024搭建商服务手册</a></el-button>
      <el-button type="primary"><a :href="file3" style="font-size:14px;color:#fff;text-decoration:none;"  target="_blank" >CAC2024 参展展品（国内）运输指南</a></el-button> -->
    </div>
    <div style="padding-bottom:100px;margin-top:10px">
      <el-table
        :data="tableData"
        stripe
        style="width: 100%">
        <el-table-column
          prop="text1"
          width='210'
          label="Important Issue"
         >
        </el-table-column>
        <el-table-column
          prop="text2"
          label="Introduction"
          >
        </el-table-column>
        <el-table-column
          prop="text3"
          width="190"
          label="Deadline">
          <template slot-scope="scope">
           <span v-html="scope.row.text3"></span>
          </template>
        </el-table-column>
        <el-table-column prop="more" label="More Details" align="center" width="310">
          <template slot-scope="scope">
            <el-button type="primary" style="width:300px"  v-if="scope.row.more =='Access Catalogue Entry' || scope.row.more =='Access Exhibitor Badge' "  @click="toLink(scope.row.address)">{{scope.row.more}}</el-button>
            <el-button type="primary" style="width:300px" v-else><a :href="scope.row.address" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank" >{{scope.row.more}}</a></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import tools from '../../utils/tools.js';
import img01 from '@/assets/img01.png'
import img02 from '@/assets/img02.png'
import img03 from '@/assets/img03.png'
export default {
  name: 'boardInfo',
  data () {
    return {
      msg: '',
      allList:[],
      rulesData: {},
      ruleForm: {
        clgID: 0
      },
      file0:'./CAC2025 Exhibitor Manual.pdf',
      file1:'./Standard Booth Exhibitor Instructions.pdf',
      file2:'./CAC2025 搭建商手册.doc',
      file3:'./CAC2025 参展展品（国内）运输指南.docx',
      saveBtnStatue: false,
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      img01:img01,
      img02:img02,
      img03:img03,
      tableData:[
        {
          text1:"E-Catalogue, Fascia and Exhibitor List Entry",
          text2:"The company name you submit for the E-Catalogue will be utilized for the exhibitor list entry and booth fascia.",
          text3:"Exhibitor list / Booth fascia <br />February 20, 2025.",
          more:'Access Catalogue Entry',
          type:'',
          address:'/magezine'
        },
        {
          text1:"Exhibitor Badge",
          text2:"Exhibitors are required to make real-name registrations. Please submit your exhibitor badge and identity information, and bring your identity certificate for entry into the hall.",
          text3:"March 16, 2025",
          more:'Access Exhibitor Badge',
          type:'',
          address:'/card'
        },
        {
          text1:"Standard Booth Package",
          text2:"Instructions regarding display panels, carpets, and standard booth package and facilities.",
          text3:"March 16, 2025",
          more:'View and Download the Document',
          type:'file',
          address:'./Standard Booth Package.pdf'
        },
        {
          text1:"Application for Standard Booth Upgrading to Raw Space Setup",
          text2:"Booths under 18 square meters are prohibited from unauthorized renovating construction or raw space construction. If raw space construction is required, companies should apply through the Official Contractor Service Platfrom.",
          text3:"January 22, 2025",
          more:' Access Application Link',
          type:'url',
          address:'http://CAC.best-expo.com.cn'
        },
        {
          text1:"Application for Electricity Box and Furniture Rental",
          text2:"Please log in to the  Official Contractor Service Platfrom to declare your requirements for electrical box and furniture rental. Please notice that the the Official Contractor will not offer furniture rental services onsite.",
          text3:"January 22, 2025",
          more:' Access Application Link',
          type:'url',
          address:'http://CAC.best-expo.com.cn'
        },
        {
          text1:"Vehicle Parking Permit and Vehicle Pass Application",
          text2:"Apply for a Parking Permit (RMB30/Pass/Time) at the Official Forwarder Service Counter in the North Entrance Lobby, collect your Vehicle Pass Form and go to the Card Centre in NH Hall (2nd floor of the North Hall) for an Unloading Area Vehicle Pass and an Unloading Area Vehicle Route Guide.",
          text3:"March 15-16, 2025",
          more:'View and Download the Document',
          type:'file',
          address:'./Vehicle Parking Permit and Vehicle Pass Application (standard).pdf'
        }
      ]
    }
  },
  mounted() {
    this.getsaasfield()
  },
  methods: {
    //禁止input输入 数字以外的字符
    inputChange(ev,val){
      this.ruleForm[val] = this.ruleForm[val].replace(/[^\d]/g,'');
    },
    rulesFn(item){
      var temp = ''
      var rulesData= {
        other:{required:item.required, message: item.fieldName+'不能为空', trigger: 'change'}
      }
      switch (item.fieldKey){
        case 'ClgBoard':
        case 'ClgEBoard':
        case 'ClgBoardExt1':
          temp = 'other'
          break;
        default: 
          temp = 'other'
          break
      }
      return rulesData[temp]
    },
    getsaasfield(){
      api.getsaasfield({type:"lintel"}).then(res => {
        if (res.data.code === 200) {
           this.allList =[]
            var _data = res.data.data
          for(var i = 0;i<_data.length;i++){
            if(_data[i].enable == 1){
              this.allList.push(_data[i])
            }
          }
          for(var j=0;j<this.allList.length;j++){
            this.$set( this.ruleForm,this.allList[j].fieldKey,"")
          }
          this.$nextTick(() => {
            this.getlinteldetail()
          })
        }
      })
    },
    getlinteldetail() {
      api.getlinteldetail(this.ruleForm).then(res => {
        if (res.data.code === 200) {
          for (var item in this.ruleForm) {
            if (res.data.data[item]) {
              this.ruleForm[item] = res.data.data[item]
            }
          }
        }
      })
    },
    submitForm(formName) {
      this.$refs.boardForm.validate((valid) => {
        if (valid) {
          api.savelintel(this.ruleForm).then(res => {
            if (res.data.code === 200) {
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success'
              });
            }
          })
        } else {
          this.$notify({
            title: '请检查表单填写项是否符合规范！',
            type: 'error'
          })
          return false;
        }
      })
    },
    toLink(str){
      this.$router.push(str)
    }
  }
}
</script>
<style lang="less">
#boardInfo{
  font-size:14px;
  .form{
    width: 50%;
    margin-top:20px;
  }
  .tips{
    padding: 20px 0;
    font-size: 14px;
    line-height: 20px;
  }
  .msg{
    padding-top: 20px;
    font-size: 14px;
    line-height: 20px;
    width: 50%;
    h3{
      font-size: 14px;
      padding-bottom: 10px;
    }
    p{
      padding:4px 0
    }
  }
  @media screen and (max-width:540px){
    .el-form-item__content{
      width: 240px;
    }
    .btns{
      text-align: center;
    }
  }
}
</style>

